import classNames from "classnames";
import { isEmpty } from "lodash-es";
import React, { useEffect, useRef } from "react";

import { isDefined } from "@utils/helpers";

import { StoreCardSkeleton } from "@components/Store/StoreSearch/components/list/storeCard/storeCard.skeleton";

import { useStorePickerContext } from "../../storePicker.context";
import { NoResults } from "./components/noResults/noResults.component";
import { StoreCardComponent } from "./components/storeCard/storeCard.component";
import "./storePickerStores.scss";

export const StorePickerStores = () => {
    const { stores, loading } = useStorePickerContext();

    const sectionRef = useRef<HTMLSelectElement>(null);

    useEffect(() => {
        sectionRef.current?.scrollTo({ top: 0, behavior: "instant" });
    }, [stores, loading]);

    if (!loading && !isDefined(stores)) return null;

    if (!loading && isEmpty(stores)) return <NoResults />;

    return (
        <section
            ref={sectionRef}
            className={classNames(
                "store-picker-stores",
                loading && "store-picker-stores--loading",
            )}
        >
            <ul>
                {!loading &&
                    stores?.map(store => (
                        <StoreCardComponent key={store.code} store={store} />
                    ))}
                {loading &&
                    Array.from({ length: 10 }, (_, i) => i + 1).map(i => (
                        <StoreCardSkeleton key={i} />
                    ))}
            </ul>
        </section>
    );
};
